import { Grid } from "@mui/material";
import "../../../styles/trangchu.scss";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { Constant } from "../../../constants/constant";

const loaiVanBanList = [
  { maMuc: "01", tenMuc: "Đánh giá tác động môi trường" },
  { maMuc: "02", tenMuc: "Kế hoạch bảo vệ môi trường" },
  { maMuc: "03", tenMuc: "Phương án bảo vệ môi trường" },
  { maMuc: "04", tenMuc: "Đề án bảo vệ môi trường" },
  { maMuc: "05", tenMuc: "Cam kết bảo vệ môi trường" },
  { maMuc: "06", tenMuc: "Đăng ký đạt tiêu chuẩn môi trường" }
];

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#f1f1f163",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary
}));
export default function ThongKeDTM({ dataThongKe }) {
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const ChuyenTrangDTM = maloai => {
    if (maloai === Constant.Ten_DTM.DTM_DGTDMT) {
      navigate(`/vanbandtm/maloai/${maloai}`);
    } else if (maloai === Constant.Ten_DTM.DTM_KHBVMT) {
      navigate(`/vanbandtm/maloai/${maloai}`);
    } else if (maloai === Constant.Ten_DTM.DTM_PABVMT) {
      navigate(`/vanbandtm/maloai/${maloai}`);
    } else if (maloai === Constant.Ten_DTM.DTM_DABVMT) {
      navigate(`/vanbandtm/maloai/${maloai}`);
    } else if (maloai === Constant.Ten_DTM.DTM_CKBVMT) {
      navigate(`/vanbandtm/maloai/${maloai}`);
    } else if (maloai === Constant.Ten_DTM.DTM_DKDTCMT) {
      navigate(`/vanbandtm/maloai/${maloai}`);
    }
  };

  useEffect(() => {
    if (dataThongKe) {
      setData([
        {
          title: loaiVanBanList[0]?.tenMuc,
          maloai: loaiVanBanList[0]?.maMuc,
          value: dataThongKe
            ? dataThongKe?.dtmTheoLoai?.Danhgiatacdongmoitruong
            : 0
        },
        {
          title: loaiVanBanList[1]?.tenMuc,
          maloai: loaiVanBanList[1]?.maMuc,
          value: dataThongKe
            ? dataThongKe?.dtmTheoLoai?.Kehoachbaovemoitruong
            : 0
        },
        {
          title: loaiVanBanList[2]?.tenMuc,
          maloai: loaiVanBanList[2]?.maMuc,
          value: dataThongKe
            ? dataThongKe?.dtmTheoLoai?.Phuonganbaovemoitruong
            : 0
        },
        {
          title: loaiVanBanList[3]?.tenMuc,
          maloai: loaiVanBanList[3]?.maMuc,
          value: dataThongKe ? dataThongKe?.dtmTheoLoai?.Deanbaovemoitruong : 0
        },
        {
          title: loaiVanBanList[4]?.tenMuc,
          maloai: loaiVanBanList[4]?.maMuc,
          value: dataThongKe
            ? dataThongKe?.dtmTheoLoai?.Camketbaovemoitruong
            : 0
        },
        {
          title: loaiVanBanList[5]?.tenMuc,
          maloai: loaiVanBanList[5]?.maMuc,
          value: dataThongKe
            ? dataThongKe?.dtmTheoLoai?.Dangkydattieuchuanmoitruong
            : 0
        }
      ]);
    }
  }, [dataThongKe]);
  return (
    <div container className="thongke-main-gp ">
      <div
        onClick={() => navigate("/vanbandtm")}
        style={{
          cursor: "pointer",
          paddingBottom: 10,
          fontSize: 18,
          fontWeight: 700,
          fontStyle: "normal"
        }}
      >
        {`TỔNG SỐ ĐTM: ${dataThongKe?.dtm || 0}`}
      </div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {data.map((record, index) => (
            <Grid item xs={6} sm={6} md={6} key={index}>
              <div className="thongke-item">
                <Item style={{ boxShadow: "none", padding: 15 }}>
                  <div
                    onClick={() => ChuyenTrangDTM(record?.maloai)}
                    className="thongke-number-dtm"
                  >
                    {record?.value}
                  </div>
                  <div className="thongke-title-dtm">{record?.title}</div>
                </Item>
              </div>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
}
